module.exports = __webpack_public_path__ + "static/media/Tags.36214d1f.svg";